import { MICROLINK_URL } from "../../../../utils/constants";
import React, { useEffect, useState } from "react";
import Instagram from "../../../../assets/images/Instagram.png";
import Fb from "../../../../assets/images/Fb.png";
import Twitter from "../../../../assets/images/Twitter.png";
import Linkedin from "../../../../assets/images/Linkedin.png";
import SocialBackground from "../../../../assets/images/SocialBackground.png";
import SocialIconsArrow from "../../../../assets/images/SocialIconsArrow.png";
import nmdfcLogo from "../../../../assets/images/nmdfc_logo.png";

const platformPosts = {
  twitter: {
  label: "X",
  handle: "@NMDFCIndia",
  icon: Twitter,
  color: "#111111",
  url: "https://x.com/NMDFCIndia",
  posts: [
    {
      id: "twitter-1",
      tag: "Ms Subaida",
      text: "Success Story",
      url: "https://x.com/NMDFCIndia/status/2056301649547960355?s=20",
    },
    {
      id: "twitter-2",
      tag: "Mr. Tarh Tagi",
      text: "Success Story",
      url: "https://x.com/NMDFCIndia/status/2037503697442496763?s=20",
    },
    {
      id: "twitter-3",
      tag: "Ms. Ryazan Gonsalves",
      text: "Success Story",
      url: "https://x.com/NMDFCIndia/status/2021449182985507059?s=20",
    },
  ],
},
 linkedin: {
  label: "LinkedIn",
  handle: "NMDFC",
  icon: Linkedin,
  color: "#0857a6",
  url: "https://www.linkedin.com/company/nmdfc/",
  posts: [
    {
      id: "linkedin-1",
      tag: "Ms Annie Kuriakose",
      text: "Success Story",
      url: "https://www.linkedin.com/posts/nmdfc_p36-ksbcdc-bhagidarisebhagyoday-activity-7410194858205872128-gfQ4",
    },
    {
      id: "linkedin-2",
      tag: "Mr. Konchok Rabgais",
      text: "Success Story",
      url: "https://www.linkedin.com/posts/nmdfc_p68-leh-ladakh-activity-7444353898787708928-jcYg",
    },
    {
      id: "linkedin-3",
      tag: "Ms Priyanka",
      text: "Success Story",
      url: "https://www.linkedin.com/posts/nmdfc_p79-ernakulam-kerala-activity-7457313442362720256-YqM_",
    },
  ],
},
 instagram: {
  label: "Instagram",
  handle: "@nmdfcindia",
  icon: Instagram,
  color: "#ad1c50",
  url: "https://www.instagram.com/nmdfcindia/",
  posts: [
    {
      id: "instagram-1",
      tag: "Mr. Urgain Tandup",
      text: "Success Story",
      url: "https://www.instagram.com/reel/DUkKhldDlks/",
    },
    {
      id: "instagram-2",
      tag: "Smt Jamshida",
      text: "Success Story",
      url: "https://www.instagram.com/reel/DXo4KfQDjH8/",
    },
    {
      id: "instagram-3",
      tag: "Dr. Aneesa",
      text: "Success Story",
      url: "https://www.instagram.com/reel/DUSbUYAjoqU/",
    },
  ],
},
facebook: {
  label: "Facebook",
  handle: "NMDFCIndiaa",
  icon: Fb,
  color: "#1258b5",
  url: "https://www.facebook.com/NMDFCIndiaa/",
  posts: [
    {
      id: "facebook-1",
      tag: "Mohd. Arshad",
      text: "Success Story",
      url: "https://www.facebook.com/share/v/1bKo6gy1pQ/",
    },
    {
      id: "facebook-2",
      tag: "Smt Shaheena Akhter",
      text: "Success Story",
      url: "https://www.facebook.com/share/v/1Ks7fcsWrZ/",
    },
    {
      id: "facebook-3",
      tag: "Sarvat SHG-MF",
      text: "Success Story",
      url: "https://www.facebook.com/share/v/1DdJvJC1qJ/",
    },
  ],
},
};

const platformOrder = ["twitter", "linkedin", "instagram", "facebook"];

const VideoSection = () => {
  const [activePlatform, setActivePlatform] = useState("twitter");
  const [postImages, setPostImages] = useState({});
  const selectedPlatform = platformPosts[activePlatform];
  const activePlatformIndex = platformOrder.indexOf(activePlatform);
  const arrowTop = 103 + activePlatformIndex * 98;

  useEffect(() => {
    let isCurrent = true;

    const fetchPostImages = async () => {
      setPostImages({});

      const imageEntries = await Promise.all(
        selectedPlatform.posts.map(async (post) => {
          try {
            const response = await fetch(
              `${MICROLINK_URL}?url=${encodeURIComponent(post.url)}`,
            );

            if (!response.ok) {
              return [post.id, null];
            }

            const result = await response.json();
            return [post.id, result.data?.image?.url || null];
          } catch (error) {
            return [post.id, null];
          }
        }),
      );

      if (isCurrent) {
        setPostImages(Object.fromEntries(imageEntries));
      }
    };

    fetchPostImages();

    return () => {
      isCurrent = false;
    };
  }, [activePlatform, selectedPlatform.posts]);

  return (
    <>
      <style>{`
        .social-trending-shell {
          box-sizing: border-box;
          width: 100%;
          max-width: 1480px;
          margin: 0 auto;
          padding: 32px clamp(20px, 3vw, 40px);
        }

        .social-trending-section {
          box-sizing: border-box;
          width: 100%;
          max-width: none;
          margin: 0 auto;
          background:
            radial-gradient(circle at 4% 8%, rgba(0, 119, 110, 0.82) 0, rgba(0, 119, 110, 0) 25%),
            radial-gradient(circle at 96% 6%, rgba(61, 92, 159, 0.72) 0, rgba(61, 92, 159, 0) 24%),
            linear-gradient(104deg, #005856 0%, #073f62 48%, #244178 100%);
        }

        .social-trending-section::before,
        .social-trending-section::after {
          content: "";
          position: absolute;
          border-radius: 999px;
          pointer-events: none;
        }

        .social-trending-section::before {
          left: -78px;
          top: -68px;
          width: 190px;
          height: 190px;
          background: rgba(1, 93, 91, 0.38);
          filter: blur(12px);
        }

        .social-trending-section::after {
          right: -82px;
          top: -68px;
          width: 210px;
          height: 210px;
          border: 28px solid rgba(255, 255, 255, 0.04);
        }

        .platform-rail {
          background-image: url(${SocialBackground});
          background-size: cover;
          background-position: center;
        }

        .post-card-copy {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .social-post-play::before {
          content: "";
          display: block;
          margin-left: 3px;
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 12px solid #ffffff;
        }

        .social-posts-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        @media (max-width: 1280px) {
          .social-posts-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: clamp(12px, 1.4vw, 18px);
          }
        }

        @media (min-width: 901px) and (max-width: 1280px) {
          .social-trending-section {
            padding-inline: clamp(22px, 2.5vw, 32px);
          }

          .social-content-layout {
            grid-template-columns: clamp(112px, 10vw, 132px) minmax(0, 1fr);
            gap: clamp(18px, 2vw, 24px);
          }

          .platform-rail {
            width: 100%;
            height: 450px;
            gap: clamp(20px, 2.4vw, 30px);
            padding-inline: 10px;
          }

          .social-post-card {
            height: 450px !important;
          }
        }

        @media (max-width: 900px) {
          .social-posts-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          .post-card-copy {
            -webkit-line-clamp: 4;
          }
        }

        @media (max-width: 520px) {
          .platform-rail {
            flex-wrap: wrap;
            max-width: 210px;
          }

          .social-post-card {
            height: 460px !important;
          }
        }

        @media (max-width: 640px) {
          .social-trending-shell {
            padding: 24px 16px;
          }

          .social-posts-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="social-trending-shell">
      <section className="social-trending-section relative min-h-[640px] overflow-hidden rounded-2xl px-12 pb-10 pt-7 shadow-[0_14px_34px_rgba(0,0,0,0.16)] max-[900px]:px-5 max-[520px]:px-3">
        <h2 className="relative z-10 m-0 text-center text-[28px] font-bold leading-tight tracking-normal text-white md:text-[40px]">
          Trending On Social Media
        </h2>
        <div className="relative z-10 mx-auto mb-9 mt-4 h-[5px] w-[64px] rounded-full bg-[#ff9b25]" />

        <div className="social-content-layout relative z-10 grid grid-cols-[152px_minmax(0,1fr)] items-stretch gap-12 max-[900px]:grid-cols-1">
          <div className="platform-rail relative flex h-[500px] w-[152px] flex-col items-center justify-center gap-[34px] rounded-[9px] px-4 py-8 max-[900px]:mx-auto max-[900px]:h-auto max-[900px]:w-full max-[900px]:flex-row max-[900px]:gap-5">
            <img
              src={SocialIconsArrow}
              alt=""
              aria-hidden="true"
              className="absolute right-[-12px] h-[3.5rem] w-auto max-[900px]:hidden"
              style={{ top: `${arrowTop}px`, transform: "translateY(-50%)" }}
            />

            {platformOrder.map((platformKey) => {
              const platform = platformPosts[platformKey];
              const isActive = activePlatform === platformKey;

              return (
                <button
                  key={platformKey}
                  type="button"
                  aria-label={`Show ${platform.label} posts`}
                  aria-pressed={isActive}
                  onClick={() => setActivePlatform(platformKey)}
                  className={`flex h-[64px] w-[64px] items-center justify-center rounded-full border-0 bg-transparent p-0 transition duration-200 ${
                    isActive ? "scale-110 shadow-[0_0_0_4px_rgba(255,255,255,0.82)]" : "hover:scale-105"
                  }`}
                >
                  <img src={platform.icon} alt="" aria-hidden="true" className="h-[64px] w-[64px] object-contain" />
                </button>
              );
            })}
          </div>

          <div className="social-posts-grid grid gap-9">
            {selectedPlatform.posts.map((post, index) => (
              <a
                key={post.id}
                href={post.url}
                target="_blank"
                rel="noopener noreferrer"
                data-skip-external-confirmation="true"
                className="social-post-card group flex h-[500px] min-w-0 flex-col overflow-hidden rounded-[8px] bg-white text-left no-underline shadow-[0_10px_24px_rgba(0,0,0,0.18)] transition duration-200 hover:-translate-y-1 hover:shadow-[0_14px_28px_rgba(0,0,0,0.22)] max-[900px]:h-[520px]"
              >
                <div className="flex items-start justify-between px-4 pb-2 pt-3">
                  <div className="flex min-w-0 items-center gap-2.5">
                    <img src={nmdfcLogo} alt="" aria-hidden="true" className="h-[34px] w-[34px] shrink-0 rounded-full object-contain" />
                    <div className="min-w-0">
                      <div className="truncate text-[12px] font-bold leading-tight text-[#1d3151]">
                        NMDFC
                      </div>
                      <div className="truncate text-[10px] font-semibold leading-tight" style={{ color: selectedPlatform.color }}>
                        {selectedPlatform.handle} - Follow
                      </div>
                    </div>
                  </div>
             
                </div>

                <div className="px-4 text-[14px] font-medium leading-[1.26] text-[#111827] max-[1180px]:text-[12px]">
                  <span className="font-bold" style={{ color: selectedPlatform.color }}>
                    {post.tag}
                  </span>{" "}
                  <span className="post-card-copy">{post.text}</span>
                  <span className="font-semibold" style={{ color: '#0e5d94' }}>Show more</span>
                </div>

                <div className="relative mx-4 mt-3 flex-1 overflow-hidden rounded-[6px] bg-[#e8e5dc]">
                  {postImages[post.id] && (
                    <img
                      src={postImages[post.id]}
                      alt={`${post.tag} success story preview`}
                      loading="lazy"
                      className="h-full min-h-[300px] w-full object-cover"
                    />
                  )}
                  <span className="social-post-play absolute left-1/2 top-1/2 flex h-[54px] w-[54px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-[4px] border-white bg-[#159fe3] shadow-[0_4px_12px_rgba(0,0,0,0.28)]" />
                </div>

              </a>
            ))}
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default VideoSection;
